var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "report-filter-container" },
    [
      _c(
        "header",
        { staticClass: "report-filter-header" },
        [
          _c(_setup.LexonBreadcrumbsComponent, {
            attrs: { items: _vm.breadcrumbs },
          }),
          _c(_setup.LfHeaderTitleComponent, {
            staticClass: "header-title",
            attrs: {
              title: _setup.props.title,
              buttons: _setup.buttons,
              executeAction: _setup.onCloseForm,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "filters-header" }, [
        _c("span", { staticClass: "filters-text" }, [
          _vm._v(" " + _vm._s(_setup.text.filtersText) + " "),
        ]),
        _c(
          "div",
          { staticClass: "buttons-container" },
          [
            _c(
              "button",
              {
                staticClass: "clear-button",
                attrs: { disabled: _setup.checkIfDisabledButton },
                on: { click: _setup.clearForm },
              },
              [_vm._v(" " + _vm._s(_setup.text.clearFilter) + " ")]
            ),
            _c(_setup.LfLabelButtonComponent, {
              staticClass: "action-button",
              attrs: {
                text: _setup.text.applyFilters,
                action: () => _setup.applyFilters(),
                disabled: _setup.checkIfDisabledButton,
                variant: _setup.LabelButtonVariant.OUTLINED,
              },
            }),
          ],
          1
        ),
      ]),
      _c(_setup.FormGeneratorComponent, {
        key: _setup.componentKey,
        staticClass: "filters-form",
        attrs: {
          schema: _setup.formSchema,
          fieldValues: _setup.formData,
          context: _setup.context,
        },
        on: { isValidForm: _setup.checkValidForm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }